import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    '-webkit-appearance': 'none',
    backgroundColor: 'white',
    border: '1px solid #979797',
    borderRadius: '100%',
    cursor: 'pointer',
    display: 'inline-block',
    position: 'relative',
    outline: 'none',
    verticalAlign: 'text-bottom',
    '&:checked': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
      boxShadow: 'inset 0px 0px 0px 2px',
    },
  },
  circle: {
    width: 25,
    height: 25,
  },
  customMargin: { margin: '0 6px 0 0' },
}));

const Radio: React.FC<any> = ({ checked, onClick, value, inputRef }) => {
  const classes = useStyles();
  return (
    <input
      type="radio"
      value={value}
      className={[classes.root, classes.circle, classes.customMargin].join(' ')}
      checked={checked}
      onChange={onClick}
      ref={inputRef}
    />
  );
};

export default Radio;
